<template>
    <div class="list">
        <div class="list-header">
            <div class="rank">排名</div>
            <div class="name">股票名称</div>
            <div class="value">{{listHeader}}</div>
        </div>
        <div class="list-body">
            <div class="list-item" :key="item.id" v-for="item in listData">
                <listItem :rank="item.rank">
                    <template v-slot:rank>{{item.rank}}</template>
                    <template v-slot:name>{{item.name}}</template>
                    <template v-slot:code>{{item.code}}.{{item.market.toUpperCase()}}</template>
                    <template v-slot:value>{{item.value}}{{listUnit}}</template>
                </listItem>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'list',
    components: {
        listItem: (resolve) => {require(["./list-item"],resolve)},
    },
    props: {
        listHeader: String,
        listUnit: String,
        listData: Array,
    },
    methods: {
        findPosY: function(obj){
            var top = 0
            if (obj.offsetParent) {
                do {
                top += obj.offsetTop
                } while (obj = obj.offsetParent)
                return [top]
            } 
        },
    },
    mounted(){
        let list = document.getElementsByClassName('list-body')[0];
        let height = (document.body.clientHeight || document.documentElement.clientHeight) - this.findPosY(list);
        list.style.height = height + 'px';
    }
}
</script>

<style lang="scss" scoped>

.list {
    position: relative;
    top: -.3rem;
    padding: .4rem .3rem;
    background: #fff;
    border-radius: .3rem .3rem 0rem 0rem;
}

.list-header {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    height: .6rem;
    border-radius: .3rem;
    font-family: 'Noto Sans SC', sans-serif;
    font-size: .26rem;
    font-weight: 700;
    white-space: nowrap;
    background: #F3F6FF;
}

.rank {
    width: .52rem;
    padding: .12rem .30rem;
    text-align: center;
}

.name {
    width: 3rem;
    padding: .12rem .30rem;
    text-align: left;
}

.value {
    width: 1.58rem;
    padding: .12rem .30rem;
    text-align: right;
}

.list-body {
    overflow: scroll;
}

</style>

